(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  var filterAnimationToken = 0;

  function toArray(list){ return Array.prototype.slice.call(list || []); }
  function normalizeFilterValue(value){ return (value || 'all').trim().toLowerCase(); }
  function parseCommaList(value){
    return (value || '')
      .split(',')
      .map(function(item){ return normalizeFilterValue(item); })
      .filter(function(item){ return !!item; });
  }
  function runWhenIdle(callback){
    if('requestIdleCallback' in window){
      window.requestIdleCallback(callback, { timeout: 1200 });
      return;
    }
    window.setTimeout(callback, 1);
  }
  function initWhenNear(selector, initializer, scope, options){
    var root = scope || document;
    var nodes = toArray(root.querySelectorAll(selector));
    var settings = options || {};
    if(!nodes.length) return;
    if(!window.IntersectionObserver){
      nodes.forEach(initializer);
      return;
    }

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        runWhenIdle(function(){ initializer(entry.target); });
      });
    }, {
      rootMargin: settings.rootMargin || '2200px 0px',
      threshold: settings.threshold || 0
    });

    nodes.forEach(function(node){
      if(node.dataset.nearInitQueued === 'true' || node.dataset.initialized === 'true') return;
      node.dataset.nearInitQueued = 'true';
      observer.observe(node);
    });
  }
  function getSignalStorageKey(sectionId, groupName){ return 'editorialSignalUnlock:' + sectionId + ':' + groupName; }
  function readSignalUnlock(sectionId, groupName){ try { return window.localStorage.getItem(getSignalStorageKey(sectionId, groupName)) === '1'; } catch(error){ return false; } }
  function writeSignalUnlock(sectionId, groupName, unlocked){
    try {
      var storageKey = getSignalStorageKey(sectionId, groupName);
      if(unlocked) window.localStorage.setItem(storageKey, '1');
      else window.localStorage.removeItem(storageKey);
    } catch(error){}
  }

  function getGridItems(){ return toArray(document.querySelectorAll('.editorial-grid .grid-item')); }
  function isItemVisible(item){ return window.getComputedStyle(item).display !== 'none'; }
  function itemMatchesFilter(item, normalizedFilter){
    var blockType = normalizeFilterValue(item.dataset.blockType || '');
    if(blockType === 'signal_reward' && item.classList.contains('is-signal-reward-locked')) return false;
    if(normalizedFilter !== 'all' && blockType === 'new_arrivals_drawer') return false;
    var itemTag = normalizeFilterValue(item.dataset.tag || '');
    return normalizedFilter === 'all' || itemTag === normalizedFilter;
  }

  function captureGridPositions(){
    var positions = new Map();
    getGridItems().forEach(function(item){
      if(!isItemVisible(item)) return;
      var content = item.querySelector('.grid-item-content');
      if(!content) return;
      positions.set(content, content.getBoundingClientRect());
    });
    return positions;
  }

  function playFilterLayoutAnimation(previousPositions){
    getGridItems().forEach(function(item){
      if(!isItemVisible(item)) return;
      var content = item.querySelector('.grid-item-content');
      var firstRect = previousPositions.get(content);
      if(!content || !firstRect) return;
      var lastRect = content.getBoundingClientRect();
      var dx = firstRect.left - lastRect.left;
      var dy = firstRect.top - lastRect.top;
      if(Math.abs(dx) < .5 && Math.abs(dy) < .5) return;
      content.style.transition = 'none';
      content.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
      content.offsetHeight;
      content.style.transition = 'transform 520ms cubic-bezier(0.22, 1, 0.36, 1), opacity 240ms ease, filter 240ms ease';
      content.style.transform = '';
      window.setTimeout(function(){ content.style.transition = ''; }, 560);
    });
  }

  function updatePrimaryFilterBar(){
    var filterBars = toArray(document.querySelectorAll('.filter-bar'));
    filterBars.forEach(function(filterBar, index){
      var isPrimary = index === 0;
      filterBar.classList.toggle('is-hidden-duplicate', !isPrimary);
      filterBar.setAttribute('aria-hidden', isPrimary ? 'false' : 'true');
    });
  }

  function getGlobalFilterTags(){
    var seen = {};
    var tags = [];
    getGridItems().forEach(function(item){
      if(item.dataset.blockType === 'signal_reward' && item.classList.contains('is-signal-reward-locked')) return;
      var tag = (item.dataset.tag || '').trim();
      var normalizedTag = normalizeFilterValue(tag);
      if(tag && normalizedTag !== 'all' && !seen[normalizedTag]){
        seen[normalizedTag] = true;
        tags.push(tag);
      }
    });
    return tags;
  }

  function getCurrentGlobalFilter(){
    var activeButton = document.querySelector('.filter-bar .filter-dropdown button.active');
    return activeButton ? normalizeFilterValue(activeButton.getAttribute('data-filter')) : 'all';
  }

  function setActiveFilterButtons(filter){
    var normalizedFilter = normalizeFilterValue(filter);
    document.querySelectorAll('.filter-bar .filter-dropdown').forEach(function(dropdown){
      var matched = false;
      dropdown.querySelectorAll('button').forEach(function(btn){
        var isMatch = normalizeFilterValue(btn.getAttribute('data-filter')) === normalizedFilter;
        btn.classList.toggle('active', isMatch);
        if(isMatch) matched = true;
      });
      if(!matched){
        var allButton = dropdown.querySelector('button[data-filter="all"]');
        if(allButton) allButton.classList.add('active');
      }
    });
  }

  function closeAllFilterBars(){ document.querySelectorAll('.filter-bar').forEach(function(filterBar){ filterBar.classList.remove('open'); }); }
  function isMobileMenuOpen(){ return !!(document.body && document.body.classList.contains('js-drawer-mobile-nav-open')); }
  function openSignalGameOverlay(overlay){ if(!overlay) return; overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden','false'); }
  function closeSignalGameOverlay(overlay){ if(!overlay) return; overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden','true'); }

  function setFeedbackText(el, text){
    if(!el) return;
    if(text){
      el.textContent = text;
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function hideSignalFeedback(wrapper){
    if(!wrapper) return;
    var feedback = wrapper.querySelector('[data-signal-feedback]');
    if(!feedback) return;
    feedback.classList.remove('is-visible','is-success','is-error');
    feedback.setAttribute('aria-hidden','true');
  }

  function showSignalFeedback(wrapper, payload){
    if(!wrapper) return;
    var feedback = wrapper.querySelector('[data-signal-feedback]');
    if(!feedback) return;

    var kickerEl = feedback.querySelector('[data-signal-feedback-kicker]');
    var headingEl = feedback.querySelector('[data-signal-feedback-heading]');
    var bodyEl = feedback.querySelector('[data-signal-feedback-body]');

    window.clearTimeout(wrapper.__signalFeedbackTimer);

    setFeedbackText(kickerEl, payload.kicker || '');
    setFeedbackText(headingEl, payload.heading || '');
    setFeedbackText(bodyEl, payload.body || '');

    feedback.classList.remove('is-success','is-error');
    feedback.classList.add('is-visible', payload.type === 'error' ? 'is-error' : 'is-success');
    feedback.setAttribute('aria-hidden','false');

    wrapper.__signalFeedbackTimer = window.setTimeout(function(){
      hideSignalFeedback(wrapper);
    }, payload.duration || 2600);
  }

  function flashSignalError(state){
    state.tiles.forEach(function(tile){
      tile.classList.remove('is-error');
      tile.offsetHeight;
      tile.classList.add('is-error');
      window.setTimeout(function(){ tile.classList.remove('is-error'); }, 440);
    });
  }

  function revealSignalRewards(wrapper, state, options){
    var settings = options || {};

    state.rewards.forEach(function(rewardRef){
      if(!rewardRef.item) return;
      rewardRef.item.classList.remove('is-signal-reward-locked');
      if(!settings.instant){
        rewardRef.item.classList.add('is-signal-reward-revealed');
        window.setTimeout(function(){ rewardRef.item.classList.remove('is-signal-reward-revealed'); }, 760);
      }
      rewardRef.item.setAttribute('aria-hidden','false');
    });

    refreshAllFilterBars();

    var activeFilter = getCurrentGlobalFilter();
    if(activeFilter !== 'all' && state.rewards[0] && state.rewards[0].item && !itemMatchesFilter(state.rewards[0].item, activeFilter)){
      setActiveFilterButtons('all');
      activeFilter = 'all';
    }

    applyGlobalFilter(activeFilter, { animate: false });

    if(settings.scroll && state.rewards[0] && state.rewards[0].item){
      window.setTimeout(function(){
        state.rewards[0].item.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, settings.instant ? 0 : 140);
    }
  }

  function setTransientSignalStatus(wrapper, state, text, duration){
    window.clearTimeout(state.statusTimer);
    state.transientStatusText = text || '';
    syncSignalTiles(wrapper);

    if(text){
      state.statusTimer = window.setTimeout(function(){
        state.transientStatusText = '';
        syncSignalTiles(wrapper);
      }, duration || 1400);
    }
  }

  function syncSignalTiles(wrapper){
    var states = wrapper.__signalStates || {};

    Object.keys(states).forEach(function(groupName){
      var state = states[groupName];
      var sequenceLength = state.sequence.length;

      state.tiles.forEach(function(tile){
        var statusEl = tile.querySelector('[data-signal-status]');
        var progressEl = tile.querySelector('[data-signal-progress]');
        var gameValue = normalizeFilterValue(tile.getAttribute('data-game-value'));
        var nextExpected = state.sequence[state.progress.length] || '';

        tile.classList.toggle('is-unlocked', !!state.unlocked);
        tile.classList.toggle('is-next-clue', !state.unlocked && !!nextExpected && gameValue === nextExpected);

        if(statusEl){
          var statusText = '';
          if(state.transientStatusText){
            statusText = state.transientStatusText;
          } else if(state.unlocked){
            statusText = state.messages.successStatus || 'Route open';
          } else if(state.progress.length && sequenceLength){
            statusText = state.progress.length + ' / ' + sequenceLength;
          } else if(state.messages.prompt){
            statusText = state.messages.prompt;
          } else if(sequenceLength){
            statusText = 'Tap in order';
          } else {
            statusText = 'No sequence';
          }
          statusEl.textContent = statusText;
        }

        if(progressEl){
          var dotsMarkup = '';
          for(var i = 0; i < sequenceLength; i += 1){
            var dotClass = 'editorial-signal-tile__dot';
            if(state.unlocked || i < state.progress.length) dotClass += ' is-filled';
            if(state.unlocked) dotClass += ' is-complete';
            dotsMarkup += '<span class="' + dotClass + '"></span>';
          }
          progressEl.innerHTML = dotsMarkup;
        }
      });

      state.rewards.forEach(function(rewardRef){
        if(!rewardRef.item || !rewardRef.panel) return;
        var shouldShow = state.unlocked || rewardRef.panel.getAttribute('data-start-unlocked') === 'true';
        rewardRef.item.classList.toggle('is-signal-reward-locked', !shouldShow);
        rewardRef.item.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      });
    });
  }

  function applyGlobalFilter(filter, options){
    var normalizedFilter = normalizeFilterValue(filter);
    var settings = options || {};
    var shouldAnimate = !!settings.animate;
    var grids = toArray(document.querySelectorAll('.editorial-grid'));
    var items = getGridItems();

    filterAnimationToken += 1;
    var animationToken = filterAnimationToken;

    grids.forEach(function(grid){ grid.classList.remove('is-filter-transitioning'); });
    items.forEach(function(item){ item.classList.remove('is-filter-hiding','is-filter-showing'); });

    if(!shouldAnimate){
      grids.forEach(function(grid){ grid.classList.toggle('is-filter-active', normalizedFilter !== 'all'); });
      items.forEach(function(item){
        var isMatch = itemMatchesFilter(item, normalizedFilter);
        item.style.display = isMatch ? '' : 'none';
        item.setAttribute('aria-hidden', isMatch ? 'false' : 'true');
      });
      return;
    }

    var previousPositions = captureGridPositions();
    var itemsToHide = [];
    var itemsToShow = [];

    items.forEach(function(item){
      var isMatch = itemMatchesFilter(item, normalizedFilter);
      var isVisibleNow = isItemVisible(item);
      if(isMatch && !isVisibleNow) itemsToShow.push(item);
      else if(!isMatch && isVisibleNow) itemsToHide.push(item);
    });

    grids.forEach(function(grid){ grid.classList.add('is-filter-transitioning'); });

    if(!itemsToHide.length && !itemsToShow.length){
      grids.forEach(function(grid){
        grid.classList.remove('is-filter-transitioning');
        grid.classList.toggle('is-filter-active', normalizedFilter !== 'all');
      });
      items.forEach(function(item){
        item.setAttribute('aria-hidden', itemMatchesFilter(item, normalizedFilter) ? 'false' : 'true');
      });
      return;
    }

    itemsToHide.forEach(function(item){
      item.classList.add('is-filter-hiding');
      item.setAttribute('aria-hidden','true');
    });

    window.setTimeout(function(){
      if(animationToken !== filterAnimationToken) return;
      grids.forEach(function(grid){ grid.classList.toggle('is-filter-active', normalizedFilter !== 'all'); });

      items.forEach(function(item){
        var isMatch = itemMatchesFilter(item, normalizedFilter);
        if(isMatch){
          item.style.display = '';
          item.setAttribute('aria-hidden','false');
        } else {
          item.style.display = 'none';
          item.setAttribute('aria-hidden','true');
          item.classList.remove('is-filter-hiding','is-filter-showing');
        }
      });

      itemsToShow.forEach(function(item){ item.classList.add('is-filter-showing'); });

      requestAnimationFrame(function(){
        if(animationToken !== filterAnimationToken) return;
        playFilterLayoutAnimation(previousPositions);
        requestAnimationFrame(function(){
          if(animationToken !== filterAnimationToken) return;
          itemsToHide.forEach(function(item){ item.classList.remove('is-filter-hiding'); });
          itemsToShow.forEach(function(item){ item.classList.remove('is-filter-showing'); });
          window.setTimeout(function(){
            if(animationToken !== filterAnimationToken) return;
            grids.forEach(function(grid){ grid.classList.remove('is-filter-transitioning'); });
          }, 560);
        });
      });
    }, itemsToHide.length ? 220 : 0);
  }

  function rebuildFilterBarButtons(filterBar, activeFilter){
    var dropdown = filterBar.querySelector('.filter-dropdown');
    if(!dropdown) return;

    dropdown.querySelectorAll('button:not([data-filter="all"])').forEach(function(btn){ btn.remove(); });

    getGlobalFilterTags().forEach(function(tag){
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('data-filter', tag);
      btn.textContent = tag;
      dropdown.appendChild(btn);
    });

    var desiredFilter = normalizeFilterValue(activeFilter);
    var matched = false;

    dropdown.querySelectorAll('button').forEach(function(btn){
      var isMatch = normalizeFilterValue(btn.getAttribute('data-filter')) === desiredFilter;
      btn.classList.toggle('active', isMatch);
      if(isMatch) matched = true;
    });

    if(!matched){
      var allButton = dropdown.querySelector('button[data-filter="all"]');
      if(allButton) allButton.classList.add('active');
    }
  }

  function refreshAllFilterBars(){
    updatePrimaryFilterBar();
    var activeFilter = getCurrentGlobalFilter();
    document.querySelectorAll('.filter-bar').forEach(function(filterBar){ rebuildFilterBarButtons(filterBar, activeFilter); });
    var resolvedFilter = getCurrentGlobalFilter();
    setActiveFilterButtons(resolvedFilter);
    applyGlobalFilter(resolvedFilter, { animate: false });
  }

  function initMusicBlock(block){
    if(block.dataset.initialized === 'true') return;
    block.dataset.initialized = 'true';

    var img = block.querySelector('.music-image');
    var iframe = block.querySelector('iframe');
    if(!img || !iframe) return;

    var originalSrc = iframe.getAttribute('src') || iframe.getAttribute('data-src');
    var isPlaying = false;
    if(!originalSrc) return;

    function soundcloudSrc(shouldPlay){
      if(originalSrc.indexOf('auto_play=') > -1){
        return originalSrc.replace(/auto_play=(true|false)/, 'auto_play=' + (shouldPlay ? 'true' : 'false'));
      }
      return originalSrc + '&auto_play=' + (shouldPlay ? 'true' : 'false');
    }

    img.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      if(!isPlaying){
        iframe.setAttribute('src', soundcloudSrc(true));
        isPlaying = true;
      } else {
        iframe.setAttribute('src', soundcloudSrc(false));
        isPlaying = false;
      }
    });
  }

  function initTerminalText(terminal){
    if(terminal.dataset.initialized === 'true') return;
    terminal.dataset.initialized = 'true';

    var source = terminal.querySelector('[data-terminal-source]');
    var output = terminal.querySelector('[data-terminal-output]');
    if(!source || !output) return;

    var typingSpeed = parseInt(terminal.getAttribute('data-typing-speed') || '26', 10);
    var prefersReducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var cursor = document.createElement('span');
    cursor.className = 'editorial-text-terminal__cursor';
    cursor.setAttribute('aria-hidden', 'true');

    if(!typingSpeed || typingSpeed < 10) typingSpeed = 26;

    function attachCursor(target){
      var cursorTarget = target || output;
      if(cursor.parentNode !== cursorTarget) cursorTarget.appendChild(cursor);
    }

    function finishTyping(){
      attachCursor(output.lastElementChild || output);
      cursor.classList.add('is-blinking');
    }

    function renderInstant(){
      output.innerHTML = source.innerHTML;
      finishTyping();
    }

    function getDelay(character){
      if(character === ' ') return Math.max(Math.round(typingSpeed * 0.45), 12);
      if(/[.,!?]/.test(character)) return typingSpeed * 5;
      if(character === '\n') return typingSpeed * 2;
      return typingSpeed;
    }

    function buildTokenStream(sourceNodes, path, tokens){
      toArray(sourceNodes).forEach(function(sourceNode){
        if(sourceNode.nodeType === 3){
          var text = sourceNode.textContent || '';
          if(!path.length && !text.trim()) return;
          for(var i = 0; i < text.length; i += 1){
            tokens.push({
              type: 'char',
              value: text.charAt(i),
              path: path.slice()
            });
          }
          return;
        }

        if(sourceNode.nodeType !== 1) return;

        if(sourceNode.tagName === 'BR'){
          tokens.push({
            type: 'br',
            path: path.slice()
          });
          return;
        }

        buildTokenStream(sourceNode.childNodes, path.concat(sourceNode), tokens);
      });
    }

    function startTyping(){
      if(terminal.dataset.started === 'true') return;
      terminal.dataset.started = 'true';
      output.innerHTML = '';
      cursor.classList.remove('is-blinking');

      if(prefersReducedMotion){
        renderInstant();
        return;
      }

      var tokens = [];
      var cloneMap = new WeakMap();
      var activeParent = null;
      var activeTextNode = null;
      var tokenIndex = 0;

      buildTokenStream(source.childNodes, [], tokens);

      if(!tokens.length){
        finishTyping();
        return;
      }

      function getTargetForPath(path){
        var parent = output;

        path.forEach(function(sourceElement){
          var clone = cloneMap.get(sourceElement);

          if(!clone){
            clone = sourceElement.cloneNode(false);
            cloneMap.set(sourceElement, clone);
            parent.appendChild(clone);
          }

          parent = clone;
        });

        return parent;
      }

      function step(){
        if(tokenIndex >= tokens.length){
          finishTyping();
          return;
        }

        var token = tokens[tokenIndex];
        var targetParent = getTargetForPath(token.path);

        tokenIndex += 1;

        if(token.type === 'br'){
          targetParent.appendChild(document.createElement('br'));
          activeParent = null;
          activeTextNode = null;
          attachCursor(targetParent);
          window.setTimeout(step, typingSpeed);
          return;
        }

        if(activeParent !== targetParent){
          activeParent = targetParent;
          activeTextNode = null;
        }

        if(!activeTextNode){
          activeTextNode = document.createTextNode('');
          targetParent.appendChild(activeTextNode);
        }

        activeTextNode.textContent += token.value;
        attachCursor(targetParent);

        window.setTimeout(step, getDelay(token.value));
      }

      step();
    }

    if(window.IntersectionObserver){
      var observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            observer.disconnect();
            startTyping();
          }
        });
      }, { threshold: 0.3 });

      observer.observe(terminal);
      return;
    }

    startTyping();
  }

  function initNewArrivalsDrawer(drawer){
    if(drawer.dataset.initialized === 'true') return;
    drawer.dataset.initialized = 'true';

    var toggle = drawer.querySelector('[data-new-arrivals-toggle]');
    var content = drawer.querySelector('.editorial-new-arrivals-content');
    if(!toggle || !content) return;

    function syncHeight(){ if(drawer.classList.contains('is-open')) content.style.maxHeight = content.scrollHeight + 'px'; }
    function setOpen(isOpen){
      drawer.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      content.style.maxHeight = isOpen ? content.scrollHeight + 'px' : '0px';
    }

    toggle.addEventListener('click', function(){ setOpen(!drawer.classList.contains('is-open')); });
    drawer.querySelectorAll('img').forEach(function(img){ if(!img.complete) img.addEventListener('load', syncHeight); });
    if(window.ResizeObserver){
      var resizeObserver = new ResizeObserver(syncHeight);
      resizeObserver.observe(content);
    }
    window.addEventListener('resize', syncHeight);
    setOpen(false);
  }

  function initFilterBar(filterBar){
    if(filterBar.dataset.initialized === 'true') return;
    filterBar.dataset.initialized = 'true';

    var toggle = filterBar.querySelector('.filter-toggle');
    var dropdown = filterBar.querySelector('.filter-dropdown');

    function closeDropdown(){ filterBar.classList.remove('open'); }
    if(toggle){ toggle.addEventListener('click', function(){ filterBar.classList.toggle('open'); }); }
    if(dropdown){
      dropdown.addEventListener('click', function(e){
        var btn = e.target.closest('button');
        if(!btn) return;
        var filter = normalizeFilterValue(btn.getAttribute('data-filter'));
        setActiveFilterButtons(filter);
        applyGlobalFilter(filter, { animate: true });
        closeDropdown();
      });
    }
  }

  function initCarousel(carousel){
    if(carousel.dataset.initialized === 'true') return;
    carousel.dataset.initialized = 'true';

    var track = carousel.querySelector('.image-carousel-track');
    var slides = carousel.querySelectorAll('.image-carousel-slide');
    var prevBtn = carousel.querySelector('.image-carousel-arrow.prev');
    var nextBtn = carousel.querySelector('.image-carousel-arrow.next');
    var dots = carousel.querySelectorAll('.image-carousel-dot');
    var clickAdvance = carousel.dataset.clickAdvance === 'true';
    var shell = carousel.closest('.grid-item-shell');
    var firstSlideTitle = shell ? shell.querySelector('[data-first-slide-title="true"]') : null;
    var firstLink = carousel.classList.contains('editorial-instagram__carousel') ? null : carousel.querySelector('.image-carousel-slide a[href]');
    var linkedHref = firstLink ? firstLink.getAttribute('href') : '';
    var hasLinkedSlides = !!linkedHref;
    var dragStartThreshold = linkedHref ? 16 : 6;
    var dragClickThreshold = linkedHref ? 16 : 8;
    if(!track || slides.length <= 1) return;
    if(hasLinkedSlides) carousel.classList.add('has-linked-slides');

    var currentIndex = 0;
    var pointerId = null;
    var startX = 0;
    var startY = 0;
    var dragDistance = 0;
    var velocityX = 0;
    var lastX = 0;
    var lastTime = 0;
    var isPointerDown = false;
    var isDragging = false;
    var isVerticalScroll = false;
    var didDrag = false;
    var pointerCaptured = false;

    function getSlideWidth(){ return carousel.getBoundingClientRect().width || slides[0].getBoundingClientRect().width || 1; }
    function updateDotsAndTitle(){
      var isFirstSlide = currentIndex === 0;
      dots.forEach(function(dot, index){ dot.classList.toggle('active', index === currentIndex); });
      if(firstSlideTitle){
        firstSlideTitle.classList.toggle('is-hidden', !isFirstSlide);
        firstSlideTitle.setAttribute('aria-hidden', isFirstSlide ? 'false' : 'true');
      }
    }
    function setTrackPosition(x, immediate){
      track.style.transition = immediate ? 'none' : '';
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
    }
    function updateCarousel(immediate){
      var offset = -currentIndex * getSlideWidth();
      setTrackPosition(offset, !!immediate);
      updateDotsAndTitle();
    }
    function goToSlide(index, immediate){
      if(index < 0) currentIndex = slides.length - 1;
      else if(index >= slides.length) currentIndex = 0;
      else currentIndex = index;
      updateCarousel(immediate);
    }
    function resetPointerState(){
      isPointerDown = false;
      isDragging = false;
      isVerticalScroll = false;
      dragDistance = 0;
      velocityX = 0;
      if(pointerCaptured && track.releasePointerCapture && pointerId != null){
        try { track.releasePointerCapture(pointerId); } catch(error){}
      }
      pointerCaptured = false;
      pointerId = null;
      track.classList.remove('is-dragging');
    }
    function onPointerDown(e){
      if(e.pointerType === 'mouse' && e.button !== 0) return;
      if(hasLinkedSlides && e.target.closest('a[href]') && e.pointerType === 'mouse') return;
      pointerId = e.pointerId;
      isPointerDown = true;
      isDragging = false;
      isVerticalScroll = false;
      didDrag = false;
      dragDistance = 0;
      velocityX = 0;
      startX = e.clientX;
      startY = e.clientY;
      lastX = e.clientX;
      lastTime = e.timeStamp || Date.now();
    }
    function onPointerMove(e){
      if(!isPointerDown || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if(!isDragging && !isVerticalScroll){
        if(Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) isVerticalScroll = true;
        else if(Math.abs(dx) > dragStartThreshold){
          isDragging = true;
          track.classList.add('is-dragging');
          if(!pointerCaptured && track.setPointerCapture){
            try {
              track.setPointerCapture(pointerId);
              pointerCaptured = true;
            } catch(error){}
          }
        }
        else return;
      }
      if(isVerticalScroll) return;

      var now = e.timeStamp || Date.now();
      var dt = Math.max(now - lastTime, 16);
      velocityX = (e.clientX - lastX) / dt;
      lastX = e.clientX;
      lastTime = now;
      dragDistance = dx;
      didDrag = didDrag || Math.abs(dx) > dragClickThreshold;

      var width = getSlideWidth();
      var resistance = 1;
      if((currentIndex === 0 && dx > 0) || (currentIndex === slides.length - 1 && dx < 0)) resistance = .35;

      var offset = (-currentIndex * width) + (dx * resistance);
      setTrackPosition(offset, true);
      e.preventDefault();
    }
    function onPointerEnd(e){
      if(!isPointerDown || (e.pointerId != null && e.pointerId !== pointerId)) return;
      track.classList.remove('is-dragging');

      if(!isDragging || isVerticalScroll){
        resetPointerState();
        updateCarousel(false);
        return;
      }

      var width = getSlideWidth();
      var distanceThreshold = Math.min(width * .18, 120);
      var velocityThreshold = .35;
      var shouldGoPrev = dragDistance > distanceThreshold || velocityX > velocityThreshold;
      var shouldGoNext = dragDistance < -distanceThreshold || velocityX < -velocityThreshold;

      resetPointerState();

      if(shouldGoPrev) goToSlide(currentIndex - 1);
      else if(shouldGoNext) goToSlide(currentIndex + 1);
      else updateCarousel(false);

      window.setTimeout(function(){ didDrag = false; }, 40);
    }

    if(prevBtn){ prevBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); goToSlide(currentIndex - 1); }); }
    if(nextBtn){ nextBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); goToSlide(currentIndex + 1); }); }
    dots.forEach(function(dot, index){ dot.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); goToSlide(index); }); });

    track.addEventListener('dragstart', function(e){ e.preventDefault(); });
    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerEnd);
    track.addEventListener('pointercancel', onPointerEnd);
    track.addEventListener('lostpointercapture', onPointerEnd);

    carousel.addEventListener('click', function(e){
      if(didDrag){ e.preventDefault(); e.stopPropagation(); didDrag = false; }
    }, true);

    track.addEventListener('click', function(e){
      if(didDrag){ e.preventDefault(); e.stopPropagation(); didDrag = false; return; }
      if(e.target.closest('button')) return;
      if(linkedHref){
        if(e.target.closest('a')) return;
        e.preventDefault();
        window.location.href = linkedHref;
        return;
      }
      if(!clickAdvance) return;
      if(e.target.closest('a')) return;
      e.preventDefault();
      goToSlide(currentIndex + 1);
    });

    window.addEventListener('resize', function(){ updateCarousel(true); });
    updateCarousel(true);
  }

  function initAutoplayVideo(video){
    if(video.dataset.initialized === 'true') return;
    video.dataset.initialized = 'true';

    var sourceLoaded = false;
    var loadObserver = null;
    var playObserver = null;

    function prepareVideo(){
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted','');
      video.setAttribute('loop','');
      video.setAttribute('playsinline','');
      video.setAttribute('webkit-playsinline','');
    }

    function ensureVideoSource(){
      var sourceUrl;
      if(sourceLoaded) return;
      sourceUrl = video.getAttribute('data-video-src') || '';
      if(sourceUrl){
        video.src = sourceUrl;
        video.preload = 'metadata';
        sourceLoaded = true;
        try { video.load(); } catch(error){}
      }
    }

    function syncVideoRatio(){
      var cropWrapper = video.closest('.editorial-media-crop');
      if(cropWrapper && video.videoWidth && video.videoHeight){
        cropWrapper.style.setProperty('--media-ratio-width', video.videoWidth);
        cropWrapper.style.setProperty('--media-ratio-height', video.videoHeight);
      }
    }

    function playVideo(){
      if(document.visibilityState && document.visibilityState !== 'visible') return;
      ensureVideoSource();
      prepareVideo();
      var playPromise = video.play();
      if(playPromise && typeof playPromise.catch === 'function') playPromise.catch(function(){});
    }

    function pauseVideo(){
      if(!video.paused) video.pause();
    }

    video.__editorialPlay = playVideo;
    video.__editorialPause = pauseVideo;

    video.addEventListener('loadedmetadata', syncVideoRatio);
    video.addEventListener('canplay', syncVideoRatio);
    prepareVideo();

    if(video.getAttribute('data-media-priority') === 'true') ensureVideoSource();

    if(window.IntersectionObserver){
      loadObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(!entry.isIntersecting) return;
          ensureVideoSource();
          loadObserver.unobserve(entry.target);
        });
      }, { rootMargin: '2200px 0px', threshold: 0 });

      playObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          video.dataset.inViewport = entry.isIntersecting ? 'true' : 'false';
          if(entry.isIntersecting) playVideo();
          else pauseVideo();
        });
      }, { rootMargin: '120px 0px', threshold: 0.12 });

      loadObserver.observe(video);
      playObserver.observe(video);
      return;
    }

    playVideo();
  }

  function initRevealBlock(block){
    if(block.dataset.initialized === 'true') return;
    block.dataset.initialized = 'true';

    var stage = block.querySelector('[data-reveal-stage]');
    var handle = block.querySelector('.editorial-reveal-handle');
    if(!stage) return;

    var startReveal = parseFloat(block.getAttribute('data-start-reveal') || '50');
    var pointerActive = false;
    var pointerCaptured = false;
    var activePointerId = null;
    var dragStartX = 0;
    var dragStartY = 0;
    var didDrag = false;
    var dragStarted = false;
    var dragThreshold = 8;

    function setReveal(percent){
      var clamped = Math.max(0, Math.min(100, percent));
      block.style.setProperty('--reveal-position', clamped + '%');
    }
    function getPercentFromEvent(e){
      var rect = stage.getBoundingClientRect();
      if(!rect.width) return startReveal;
      return ((e.clientX - rect.left) / rect.width) * 100;
    }

    function capturePointer(e){
      if(pointerCaptured || !stage.setPointerCapture) return;
      try {
        stage.setPointerCapture(e.pointerId);
        pointerCaptured = true;
      } catch(error){}
    }

    function releasePointer(e){
      if(e && activePointerId != null && e.pointerId !== activePointerId) return;
      if(pointerCaptured && stage.releasePointerCapture && activePointerId != null){
        try { stage.releasePointerCapture(activePointerId); } catch(error){}
      }
      pointerActive = false;
      pointerCaptured = false;
      activePointerId = null;
      dragStarted = false;
    }

    stage.addEventListener('pointerdown', function(e){
      if(e.pointerType === 'mouse' && e.button !== 0) return;
      pointerActive = true;
      activePointerId = e.pointerId;
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      didDrag = false;
      dragStarted = !!e.target.closest('.editorial-reveal-handle');

      if(dragStarted){
        capturePointer(e);
        setReveal(getPercentFromEvent(e));
        e.preventDefault();
      }
    });

    stage.addEventListener('pointermove', function(e){
      if(!pointerActive || e.pointerId !== activePointerId) return;

      var dx = e.clientX - dragStartX;
      var dy = e.clientY - dragStartY;

      if(!dragStarted){
        if(Math.abs(dx) < dragThreshold && Math.abs(dy) < dragThreshold) return;
        if(Math.abs(dy) > Math.abs(dx)) return;

        dragStarted = true;
        didDrag = true;
        capturePointer(e);
      } else if(Math.abs(dx) > 2){
        didDrag = true;
      }

      setReveal(getPercentFromEvent(e));
      e.preventDefault();
    });

    stage.addEventListener('pointerup', releasePointer);
    stage.addEventListener('pointercancel', releasePointer);
    stage.addEventListener('lostpointercapture', releasePointer);
    stage.addEventListener('click', function(e){
      if(!didDrag) return;
      didDrag = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
    if(handle){
      handle.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
      });
    }
    setReveal(startReveal);
  }

  function initCctvBoard(board){
    if(board.dataset.initialized === 'true') return;
    board.dataset.initialized = 'true';

    var pins = toArray(board.querySelectorAll('[data-cctv-pin]'));
    var stage = board.querySelector('[data-cctv-stage]') || board;
    var focusZoom = parseFloat(board.getAttribute('data-focus-zoom') || '108');
    var defaultSource = board.querySelector('[data-cctv-default-source]');
    var panel = board.querySelector('[data-cctv-panel]');
    var panelKicker = board.querySelector('[data-cctv-panel-kicker]');
    var panelHeading = board.querySelector('[data-cctv-panel-heading]');
    var panelBody = board.querySelector('[data-cctv-panel-body]');
    var panelCount = board.querySelector('[data-cctv-panel-count]');
    var activePin = null;
    var panelSwapTimer = null;

    if(!defaultSource || !panel || !panelKicker || !panelHeading || !panelBody || !panelCount) return;
    if(!focusZoom || focusZoom < 100) focusZoom = 108;

    function readSource(source){
      if(!source) return { kicker: '', heading: '', body: '' };
      var kicker = source.querySelector('[data-cctv-source-kicker]');
      var heading = source.querySelector('[data-cctv-source-heading]');
      var body = source.querySelector('[data-cctv-source-body]');
      return {
        kicker: kicker ? kicker.textContent : '',
        heading: heading ? heading.textContent : '',
        body: body ? body.innerHTML : ''
      };
    }

    function resetFocus(){
      board.classList.remove('is-focused');
      board.style.setProperty('--cctv-focus-translate-x', '0px');
      board.style.setProperty('--cctv-focus-translate-y', '0px');
      board.style.setProperty('--cctv-focus-scale', '1');
    }

    function setFocus(pin){
      var focusX;
      var focusY;
      var scale;
      var rect;
      var tx;
      var ty;

      if(!pin){
        resetFocus();
        return;
      }

      focusX = parseFloat(pin.getAttribute('data-focus-x') || '50');
      focusY = parseFloat(pin.getAttribute('data-focus-y') || '50');
      scale = focusZoom / 100;
      rect = stage.getBoundingClientRect();
      tx = ((50 - focusX) / 100) * rect.width * (scale - 1);
      ty = ((50 - focusY) / 100) * rect.height * (scale - 1);

      board.classList.add('is-focused');
      board.style.setProperty('--cctv-focus-translate-x', tx.toFixed(2) + 'px');
      board.style.setProperty('--cctv-focus-translate-y', ty.toFixed(2) + 'px');
      board.style.setProperty('--cctv-focus-scale', scale.toFixed(3));
    }

    function writePanel(content){
      panelKicker.textContent = content.kicker || '';
      panelKicker.hidden = !content.kicker;
      panelHeading.textContent = content.heading || '';
      panelHeading.hidden = !content.heading;
      panelBody.innerHTML = content.body || '';
      panelBody.hidden = !content.body;
    }

    function swapPanel(content, instant){
      window.clearTimeout(panelSwapTimer);

      if(instant){
        panel.classList.remove('is-swapping');
        writePanel(content);
        return;
      }

      panel.classList.add('is-swapping');
      panelSwapTimer = window.setTimeout(function(){
        writePanel(content);
        requestAnimationFrame(function(){ panel.classList.remove('is-swapping'); });
      }, 110);
    }

    function activatePin(pin, options){
      var content;
      var index;
      var settings = options || {};

      activePin = pin || null;
      pins.forEach(function(currentPin){ currentPin.classList.toggle('is-active', currentPin === pin); });

      if(pin){
        content = readSource(pin.querySelector('.editorial-cctv-board__source'));
        index = pins.indexOf(pin);
        panelCount.textContent = 'Marker ' + (index + 1) + ' / ' + pins.length;
      } else {
        content = readSource(defaultSource);
        panelCount.textContent = pins.length ? 'Tap marker to inspect' : 'No markers added';
      }

      setFocus(pin);
      swapPanel(content, !!settings.instant);
    }

    pins.forEach(function(pin){
      pin.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        if(activePin === pin) activatePin(null);
        else activatePin(pin);
      });
    });

    if(window.ResizeObserver){
      var cctvResizeObserver = new ResizeObserver(function(){
        if(activePin) setFocus(activePin);
      });
      cctvResizeObserver.observe(stage);
    } else {
      window.addEventListener('resize', function(){
        if(activePin) setFocus(activePin);
      });
    }

    activatePin(null, { instant: true });
  }

  function initInstagramCampaign(campaign){
    if(campaign.dataset.instagramInitialized === 'true') return;
    campaign.dataset.instagramInitialized = 'true';

    var storageKey = campaign.getAttribute('data-comment-storage-key') || '';
    var likeStorageKey = campaign.getAttribute('data-like-storage-key') || '';
    var startingLikes = parseInt(campaign.getAttribute('data-starting-likes') || '0', 10);
    var shareUrl = campaign.getAttribute('data-share-url') || '';
    var commentUsername = campaign.getAttribute('data-comment-username') || 'guest';
    var commentEmail = campaign.getAttribute('data-comment-email') || '';
    var commentCustomerId = campaign.getAttribute('data-comment-customer-id') || '';
    var commentApiEnabled = campaign.getAttribute('data-comment-api-enabled') === 'true';
    var commentApiUrl = campaign.getAttribute('data-comment-api-url') || '';
    var commentChannel = campaign.getAttribute('data-comment-channel') || 'main';
    var turnstileSiteKey = campaign.getAttribute('data-turnstile-site-key') || '';
    var sharedComments = campaign.getAttribute('data-shared-comments') === 'true';
    var commentsArticleId = campaign.getAttribute('data-comments-article-id') || '';
    var commentsModerated = campaign.getAttribute('data-comments-moderated') === 'true';
    var commentFilterEnabled = campaign.getAttribute('data-comment-filter-enabled') === 'true';
    var blockedCommentAction = campaign.getAttribute('data-comment-blocked-action') || 'censor';
    var blockedWordReplacement = campaign.getAttribute('data-comment-replacement') || '****';
    var commentDeleteEnabled = !sharedComments && campaign.getAttribute('data-comment-delete-enabled') === 'true';
    var commentsContainer = campaign.querySelector('[data-instagram-comments]');
    var commentForm = campaign.querySelector('[data-instagram-comment-form]') || campaign.querySelector('form.editorial-instagram__comment');
    var commentFrame = campaign.querySelector('[data-instagram-comment-frame]');
    var commentEmailInput = campaign.querySelector('[data-instagram-comment-email]');
    var commentInput = campaign.querySelector('[data-instagram-comment-input]');
    var commentSubmit = campaign.querySelector('[data-instagram-comment-submit]');
    var commentFeedback = campaign.querySelector('[data-instagram-comment-feedback]');
    var turnstileContainer = campaign.querySelector('[data-instagram-turnstile]');
    var emojiToggle = campaign.querySelector('[data-instagram-emoji-toggle]');
    var emojiPicker = campaign.querySelector('[data-instagram-emoji-picker]');
    var likeButton = campaign.querySelector('[data-instagram-like]');
    var likeCount = campaign.querySelector('[data-instagram-like-count]');
    var shareButton = campaign.querySelector('[data-instagram-share]');
    var commentTrigger = campaign.querySelector('[data-instagram-comment-trigger]');
    var hotspotWraps = toArray(campaign.querySelectorAll('.editorial-instagram__hotspot-wrap'));
    var carouselTrack = campaign.querySelector('.editorial-instagram__track');
    var feedbackTimer = null;
    var commentSubmitting = false;
    var commentSyncBusy = false;
    var commentSyncTimer = null;
    var commentResponseTimer = null;
    var pendingSharedComment = '';
    var apiCommentCacheKey = 'editorial-instagram-api-comments:' + commentChannel;
    var turnstileWidgetId = null;
    var turnstileRetryUsed = false;
    var turnstileRetryTimer = null;
    var commentSubmitLabel = commentSubmit ? commentSubmit.textContent : 'Post';
    var blockedWordsValue = '';

    function getAnonymousCommentId(){
      var identityKey = 'editorialInstagramCommenterId';
      var identity = '';

      try {
        identity = window.localStorage.getItem(identityKey) || '';
        if(!identity){
          identity = Math.random().toString(36).slice(2,10) + Date.now().toString(36).slice(-5);
          window.localStorage.setItem(identityKey, identity);
        }
      } catch(error){
        identity = Math.random().toString(36).slice(2,10);
      }

      return identity.replace(/[^a-z0-9]/gi,'').toLowerCase();
    }

    if(commentEmailInput){
      var emailDomain = (commentEmailInput.getAttribute('data-email-domain') || window.location.hostname || '')
        .replace(/^www\./i,'')
        .replace(/:\d+$/,'');
      if(emailDomain) commentEmailInput.value = 'guest-' + getAnonymousCommentId() + '@' + emailDomain;
    }

    function useNativeMobileCommentSubmission(){
      return !!(window.matchMedia && window.matchMedia('(max-width: 768px)').matches);
    }

    try {
      blockedWordsValue = JSON.parse(campaign.getAttribute('data-comment-blocked-words') || '""') || '';
    } catch(error){
      blockedWordsValue = campaign.getAttribute('data-comment-blocked-words') || '';
    }

    var blockedWords = blockedWordsValue
      .split(/[\n,]+/)
      .map(function(word){ return word.trim(); })
      .filter(function(word){ return !!word; })
      .sort(function(a,b){ return b.length - a.length; });

    function escapeRegExp(value){
      return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function moderateComment(value){
      var output = value || '';
      var matched = false;

      if(!commentFilterEnabled || !blockedWords.length){
        return { matched: false, text: output };
      }

      blockedWords.forEach(function(word){
        var pattern = new RegExp('(^|[^A-Za-z0-9_])(' + escapeRegExp(word) + ')(?=$|[^A-Za-z0-9_])', 'gi');
        output = output.replace(pattern, function(match, prefix){
          matched = true;
          return prefix + blockedWordReplacement;
        });
      });

      return { matched: matched, text: output };
    }

    function showCommentFeedback(message){
      if(!commentFeedback) return;
      window.clearTimeout(feedbackTimer);
      commentFeedback.textContent = message || '';
      commentFeedback.classList.toggle('is-visible', !!message);
      if(message){
        feedbackTimer = window.setTimeout(function(){
          commentFeedback.classList.remove('is-visible');
        }, 2600);
      }
    }

    function createCommentId(){
      return 'comment-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2,8);
    }

    function setEmojiPickerOpen(isOpen){
      if(!emojiPicker || !emojiToggle) return;
      emojiPicker.classList.toggle('is-open', isOpen);
      emojiPicker.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      emojiToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    function emojiFromCodeSequence(sequence){
      return (sequence || '')
        .split('-')
        .map(function(code){ return String.fromCodePoint(parseInt(code,16)); })
        .join('');
    }

    function buildEmojiPicker(){
      if(!emojiPicker || emojiPicker.dataset.built === 'true') return;
      emojiPicker.dataset.built = 'true';

      (emojiPicker.getAttribute('data-emoji-codes') || '')
        .split(',')
        .filter(function(sequence){ return !!sequence; })
        .forEach(function(sequence){
          var emoji = emojiFromCodeSequence(sequence);
          var option = document.createElement('button');
          option.type = 'button';
          option.className = 'editorial-instagram__emoji-option';
          option.setAttribute('data-instagram-emoji-code', sequence);
          option.setAttribute('aria-label', 'Insert emoji');
          option.textContent = emoji;
          emojiPicker.appendChild(option);
        });
    }

    function insertEmoji(emoji){
      if(!commentInput || !emoji) return;
      var value = commentInput.value || '';
      var start = typeof commentInput.selectionStart === 'number' ? commentInput.selectionStart : value.length;
      var end = typeof commentInput.selectionEnd === 'number' ? commentInput.selectionEnd : start;
      var nextValue = value.slice(0,start) + emoji + value.slice(end);

      if(nextValue.length > 280) return;

      commentInput.value = nextValue;
      commentInput.focus();
      var caret = start + emoji.length;
      if(commentInput.setSelectionRange) commentInput.setSelectionRange(caret,caret);
      commentInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function readLikeState(){
      if(!likeStorageKey) return false;
      try { return window.localStorage.getItem(likeStorageKey) === '1'; } catch(error){ return false; }
    }

    function writeLikeState(isLiked){
      if(!likeStorageKey) return;
      try {
        if(isLiked) window.localStorage.setItem(likeStorageKey, '1');
        else window.localStorage.removeItem(likeStorageKey);
      } catch(error){}
    }

    function syncLikeState(isLiked){
      var displayedLikes = Math.max(0, startingLikes) + (isLiked ? 1 : 0);
      if(likeButton){
        likeButton.classList.toggle('is-liked', isLiked);
        likeButton.setAttribute('aria-pressed', isLiked ? 'true' : 'false');
        likeButton.setAttribute('aria-label', isLiked ? 'Unlike post' : 'Like post');
      }
      if(likeCount){
        likeCount.textContent = displayedLikes.toLocaleString() + (displayedLikes === 1 ? ' like' : ' likes');
      }
    }

    function getShareUrl(){
      if(!shareUrl) return window.location.href;
      try { return new URL(shareUrl, window.location.href).href; } catch(error){ return shareUrl; }
    }

    function legacyCopyText(value){
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly','');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      var copied = false;
      try { copied = document.execCommand('copy'); } catch(error){}
      textarea.remove();
      return copied;
    }

    function copyShareLink(){
      var value = getShareUrl();
      if(navigator.clipboard && typeof navigator.clipboard.writeText === 'function'){
        navigator.clipboard.writeText(value).then(function(){
          showCommentFeedback('Link copied to clipboard.');
        }).catch(function(){
          showCommentFeedback(legacyCopyText(value) ? 'Link copied to clipboard.' : 'Unable to copy link.');
        });
        return;
      }
      showCommentFeedback(legacyCopyText(value) ? 'Link copied to clipboard.' : 'Unable to copy link.');
    }

    function closeHotspots(exceptWrap){
      hotspotWraps.forEach(function(wrap){
        var shouldOpen = wrap === exceptWrap;
        var button = wrap.querySelector('[data-instagram-hotspot]');
        wrap.classList.toggle('is-open', shouldOpen);
        if(button) button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      });
    }

    hotspotWraps.forEach(function(wrap){
      var button = wrap.querySelector('[data-instagram-hotspot]');
      if(!button) return;
      button.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var directUrl = button.getAttribute('data-hotspot-url') || '';
        if(button.getAttribute('data-hotspot-direct') === 'true' && directUrl){
          window.location.href = directUrl;
          return;
        }
        closeHotspots(wrap.classList.contains('is-open') ? null : wrap);
      });
      wrap.addEventListener('click', function(e){ e.stopPropagation(); });
    });

    campaign.addEventListener('click', function(e){
      if(!e.target.closest('.editorial-instagram__hotspot-wrap')) closeHotspots(null);
    });
    document.addEventListener('click', function(e){
      if(!campaign.contains(e.target)) closeHotspots(null);
    });
    if(carouselTrack){
      carouselTrack.addEventListener('pointerdown', function(e){
        if(!e.target.closest('.editorial-instagram__hotspot-wrap')) closeHotspots(null);
      });
    }

    function readComments(){
      if(sharedComments) return [];
      if(!storageKey) return [];
      try {
        var stored = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
        if(!Array.isArray(stored)) return [];

        var changed = false;
        var moderatedComments = [];

        stored.slice(-50).forEach(function(comment){
          var moderation = moderateComment(comment.text || '');

          if(moderation.matched && blockedCommentAction === 'reject'){
            changed = true;
            return;
          }

          if(!comment.id){
            comment.id = createCommentId();
            changed = true;
          }

          if(moderation.text !== comment.text){
            comment.text = moderation.text;
            changed = true;
          }

          moderatedComments.push(comment);
        });

        if(changed) writeComments(moderatedComments);
        return moderatedComments;
      } catch(error){
        return [];
      }
    }

    function writeComments(comments){
      if(sharedComments) return;
      if(!storageKey) return;
      try { window.localStorage.setItem(storageKey, JSON.stringify(comments.slice(-50))); } catch(error){}
    }

    function renderComments(comments){
      if(!commentsContainer) return;
      commentsContainer.innerHTML = '';
      comments.forEach(function(comment){
        var entry = document.createElement('div');
        var copy = document.createElement('span');
        var username = document.createElement('strong');
        var text = document.createTextNode(comment.text || comment.body || '');
        var time = document.createElement('span');
        var deleteButton = null;
        var displayName = comment.username || comment.author || commentUsername;

        entry.className = 'editorial-instagram__comment-entry';
        entry.setAttribute('data-comment-id', comment.id || '');
        username.textContent = displayName;
        copy.appendChild(username);
        copy.appendChild(text);
        time.className = 'editorial-instagram__comment-time';
        time.textContent = comment.time || formatCommentTime(comment.createdAt);
        entry.appendChild(copy);
        entry.appendChild(time);
        if(commentDeleteEnabled){
          deleteButton = document.createElement('button');
          deleteButton.type = 'button';
          deleteButton.className = 'editorial-instagram__comment-delete';
          deleteButton.setAttribute('data-instagram-comment-delete', comment.id || '');
          deleteButton.setAttribute('aria-label', 'Delete comment by ' + displayName);
          deleteButton.textContent = 'Delete';
          entry.appendChild(deleteButton);
        }
        commentsContainer.appendChild(entry);
      });
    }

    function formatCommentTime(value){
      if(!value) return 'now';
      var timestamp = Date.parse(value);
      if(!timestamp) return 'now';
      var elapsed = Math.max(0, Date.now() - timestamp);
      var minutes = Math.floor(elapsed / 60000);
      if(minutes < 1) return 'now';
      if(minutes < 60) return minutes + 'm';
      var hours = Math.floor(minutes / 60);
      if(hours < 24) return hours + 'h';
      try {
        return new Date(timestamp).toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
      } catch(error){
        return new Date(timestamp).toLocaleDateString();
      }
    }

    function appendSharedComment(text, isPending){
      if(!commentsContainer) return;

      var setupMessage = commentsContainer.querySelector('.editorial-instagram__comments-setup');
      var entry = document.createElement('div');
      var copy = document.createElement('span');
      var username = document.createElement('strong');
      var time = document.createElement('span');

      if(setupMessage) setupMessage.remove();
      entry.className = 'editorial-instagram__comment-entry is-new';
      entry.setAttribute('data-pending-comment', 'true');
      username.textContent = commentUsername;
      copy.appendChild(username);
      copy.appendChild(document.createTextNode(text || ''));
      entry.setAttribute('data-comment-key', (copy.textContent || '').replace(/\s+/g,' ').trim().toLowerCase());
      time.className = 'editorial-instagram__comment-time';
      time.textContent = isPending ? 'pending approval' : 'now';
      entry.appendChild(copy);
      entry.appendChild(time);
      commentsContainer.insertBefore(entry, commentsContainer.firstChild);
    }

    function getCommentApiUrl(){
      if(!commentApiUrl) return '';
      try {
        var url = new URL(commentApiUrl, window.location.origin);
        url.searchParams.set('channel', commentChannel);
        return url.href;
      } catch(error){
        return commentApiUrl;
      }
    }

    function getCommentApiCredentials(apiUrl){
      try {
        return new URL(apiUrl, window.location.origin).origin === window.location.origin ? 'same-origin' : 'omit';
      } catch(error){
        return 'omit';
      }
    }

    function loadTurnstileScript(){
      if(window.turnstile && typeof window.turnstile.render === 'function'){
        return Promise.resolve(window.turnstile);
      }
      if(window.__editorialTurnstilePromise) return window.__editorialTurnstilePromise;

      window.__editorialTurnstilePromise = new Promise(function(resolve, reject){
        var existing = document.querySelector('script[data-editorial-turnstile-script]');
        var script = existing || document.createElement('script');
        var timeout = window.setTimeout(function(){
          reject(new Error('Turnstile took too long to load.'));
        }, 12000);

        function handleLoad(){
          window.clearTimeout(timeout);
          if(window.turnstile) resolve(window.turnstile);
          else reject(new Error('Turnstile did not initialize.'));
        }

        function handleError(){
          window.clearTimeout(timeout);
          reject(new Error('Turnstile could not be loaded.'));
        }

        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });

        if(!existing){
          script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          script.async = true;
          script.defer = true;
          script.setAttribute('data-editorial-turnstile-script','true');
          document.head.appendChild(script);
        }
      });

      return window.__editorialTurnstilePromise;
    }

    function resetApiCommentSubmission(){
      window.clearTimeout(turnstileRetryTimer);
      commentSubmitting = false;
      pendingSharedComment = '';
      turnstileRetryUsed = false;
      if(commentSubmit){
        commentSubmit.textContent = commentSubmitLabel;
        commentSubmit.disabled = !commentInput || !commentInput.value.trim();
      }
      if(window.turnstile && turnstileWidgetId !== null){
        try { window.turnstile.remove(turnstileWidgetId); } catch(error){}
      }
      turnstileWidgetId = null;
      if(turnstileContainer) turnstileContainer.innerHTML = '';
    }

    function readApiCommentCache(){
      if(!apiCommentCacheKey) return [];
      try {
        var cached = JSON.parse(window.localStorage.getItem(apiCommentCacheKey) || '[]');
        return Array.isArray(cached) ? cached : [];
      } catch(error){
        return [];
      }
    }

    function writeApiCommentCache(commentsToCache){
      if(!apiCommentCacheKey || !Array.isArray(commentsToCache)) return;
      try {
        window.localStorage.setItem(apiCommentCacheKey, JSON.stringify(commentsToCache.slice(-100)));
      } catch(error){}
    }

    function syncApiComments(){
      if(!commentApiEnabled || !commentsContainer || commentSyncBusy || document.hidden) return;
      if(!document.documentElement.contains(campaign)){
        window.clearInterval(commentSyncTimer);
        return;
      }

      var apiUrl = getCommentApiUrl();
      if(!apiUrl) return;
      commentSyncBusy = true;

      window.fetch(apiUrl, {
        method: 'GET',
        credentials: getCommentApiCredentials(apiUrl),
        cache: 'no-store',
        headers: { 'Accept': 'application/json' }
      }).then(function(response){
        return response.json().catch(function(){ return {}; }).then(function(payload){
          if(!response.ok || !payload.ok) throw new Error(payload.error || 'Comments could not be loaded.');
          return payload;
        });
      }).then(function(payload){
        var apiComments = Array.isArray(payload.comments) ? payload.comments : [];
        writeApiCommentCache(apiComments);
        renderComments(apiComments);
      }).catch(function(){
        var cachedComments = readApiCommentCache();
        if(cachedComments.length && !commentsContainer.children.length){
          renderComments(cachedComments);
        }
        if(!commentsContainer.children.length && window.Shopify && window.Shopify.designMode){
          commentsContainer.innerHTML = '<div class="editorial-instagram__comments-setup">Deploy and connect the shared comment service to load comments.</div>';
        }
      }).then(function(){
        commentSyncBusy = false;
      });
    }

    function submitApiComment(turnstileToken){
      var apiUrl = getCommentApiUrl();
      if(!apiUrl || !pendingSharedComment){
        showCommentFeedback('Comment service is not configured.');
        resetApiCommentSubmission();
        return;
      }

      var honeypot = commentForm ? commentForm.querySelector('input[name="website"]') : null;

      window.fetch(apiUrl, {
        method: 'POST',
        credentials: getCommentApiCredentials(apiUrl),
        cache: 'no-store',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          channel: commentChannel,
          author: commentUsername,
          email: commentEmail,
          customerId: commentCustomerId,
          body: pendingSharedComment,
          website: honeypot ? honeypot.value : '',
          turnstileToken: turnstileToken
        })
      }).then(function(response){
        return response.json().catch(function(){ return {}; }).then(function(payload){
          if(!response.ok || !payload.ok) throw new Error(payload.error || 'Comment could not be posted.');
          return payload;
        });
      }).then(function(payload){
        if(commentInput) commentInput.value = '';
        showCommentFeedback(payload.filtered ? 'Comment posted with blocked language filtered.' : 'Comment posted for everyone.');
        resetApiCommentSubmission();
        syncApiComments();
      }).catch(function(error){
        showCommentFeedback(error && error.message ? error.message : 'Comment could not be posted.');
        resetApiCommentSubmission();
      });
    }

    function initializeTurnstile(options){
      if(!commentApiEnabled || !turnstileContainer || !turnstileSiteKey){
        return Promise.reject(new Error('Comment verification is not configured.'));
      }

      var settings = options || {};

      return loadTurnstileScript().then(function(turnstile){
        if(turnstileWidgetId !== null){
          try { turnstile.remove(turnstileWidgetId); } catch(error){}
          turnstileWidgetId = null;
        }
        turnstileContainer.innerHTML = '';

        turnstileWidgetId = turnstile.render(turnstileContainer, {
          sitekey: turnstileSiteKey,
          action: 'instagram_comment',
          appearance: settings.fallback ? 'always' : 'interaction-only',
          size: settings.fallback || (window.matchMedia && window.matchMedia('(max-width: 359px)').matches) ? 'compact' : 'flexible',
          theme: 'auto',
          retry: 'auto',
          'retry-interval': 1000,
          'refresh-expired': 'auto',
          callback: function(token){ submitApiComment(token); },
          'error-callback': function(errorCode){
            if(commentSubmitting && !turnstileRetryUsed){
              turnstileRetryUsed = true;
              if(window.console && console.warn) console.warn('Turnstile retrying after error:', errorCode || 'unknown');
              try { turnstile.remove(turnstileWidgetId); } catch(error){}
              turnstileWidgetId = null;
              turnstileContainer.innerHTML = '';
              showCommentFeedback('Retrying verification...');
              turnstileRetryTimer = window.setTimeout(function(){
                initializeTurnstile({ fallback: true }).catch(function(){
                  showCommentFeedback('Verification could not start. Please try again.');
                  resetApiCommentSubmission();
                });
              }, 300);
              return;
            }
            showCommentFeedback('Verification could not start. Please try again.');
            resetApiCommentSubmission();
          },
          'expired-callback': function(){
            if(commentSubmitting){
              showCommentFeedback('Verification expired. Please post again.');
              resetApiCommentSubmission();
            }
          },
          'timeout-callback': function(){
            showCommentFeedback('Verification timed out. Please try again.');
            resetApiCommentSubmission();
          }
        });

        return turnstileWidgetId;
      });
    }

    function startApiCommentSubmission(){
      turnstileRetryUsed = false;
      initializeTurnstile().then(function(){
        if(!commentSubmitting) resetApiCommentSubmission();
        else showCommentFeedback('Checking comment...');
      }).catch(function(error){
        showCommentFeedback(error && error.message ? error.message : 'Verification is temporarily unavailable.');
        resetApiCommentSubmission();
      });
    }

    function resetSharedCommentSubmission(options){
      var settings = options || {};
      window.clearTimeout(commentResponseTimer);
      commentSubmitting = false;
      pendingSharedComment = '';

      if(settings.resetFrame !== false && commentFrame){
        window.setTimeout(function(){
          try { commentFrame.src = 'about:blank'; } catch(error){}
        }, 0);
      }

      if(commentSubmit){
        commentSubmit.textContent = commentSubmitLabel;
        commentSubmit.disabled = !commentInput || !commentInput.value.trim();
      }
    }

    function completeSharedCommentSubmission(){
      if(!commentSubmitting || !pendingSharedComment) return;

      appendSharedComment(pendingSharedComment, commentsModerated);
      if(commentInput) commentInput.value = '';
      showCommentFeedback(commentsModerated ? 'Comment submitted for approval.' : 'Comment posted for everyone.');
      resetSharedCommentSubmission();
      window.setTimeout(syncSharedComments, 1200);
      window.setTimeout(syncSharedComments, 4000);
    }

    function handleCommentFrameLoad(){
      if(!commentSubmitting || !commentFrame) return;

      var frameLocation = '';
      var frameDocument = null;

      try {
        frameLocation = commentFrame.contentWindow.location.href || '';
        frameDocument = commentFrame.contentDocument || commentFrame.contentWindow.document;
      } catch(error){
        completeSharedCommentSubmission();
        return;
      }

      if(!frameLocation || frameLocation === 'about:blank' || !frameDocument) return;

      var commentError = frameDocument.querySelector(
        '#CommentForm-author-error, #CommentForm-email-error, #CommentForm-body-error, .form-status-list a[href*="CommentForm-"]'
      );

      if(commentError){
        showCommentFeedback((commentError.textContent || 'Shopify rejected this comment.').replace(/\s+/g,' ').trim());
        resetSharedCommentSubmission();
        return;
      }

      completeSharedCommentSubmission();
    }

    function getCommentEntryKey(entry){
      var copy = entry ? entry.firstElementChild : null;
      return (copy ? copy.textContent : '')
        .replace(/\s+/g,' ')
        .trim()
        .toLowerCase();
    }

    function syncSharedComments(){
      if(commentApiEnabled){
        syncApiComments();
        return;
      }
      if(!sharedComments || !commentsArticleId || !commentsContainer || commentSyncBusy || document.hidden) return;
      if(!document.documentElement.contains(campaign)){
        window.clearInterval(commentSyncTimer);
        return;
      }

      commentSyncBusy = true;

      var refreshUrl;
      try {
        refreshUrl = new URL(window.location.href);
        refreshUrl.hash = '';
        refreshUrl.searchParams.set('_instagram_comments', Date.now().toString());
      } catch(error){
        commentSyncBusy = false;
        return;
      }

      window.fetch(refreshUrl.href, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function(response){
        if(!response.ok) throw new Error('Comment refresh failed');
        return response.text();
      }).then(function(markup){
        var parsed = new DOMParser().parseFromString(markup, 'text/html');
        var sourceCampaign = null;

        toArray(parsed.querySelectorAll('[data-instagram-campaign]')).some(function(candidate){
          var candidateArticleId = candidate.getAttribute('data-comments-article-id') || '';

          if(candidateArticleId === commentsArticleId){
            sourceCampaign = candidate;
            return true;
          }
          return false;
        });

        if(!sourceCampaign) return;

        var sourceComments = sourceCampaign.querySelector('[data-instagram-comments]');
        if(!sourceComments) return;

        var pendingEntries = toArray(commentsContainer.querySelectorAll('[data-pending-comment="true"]'));
        var serverKeys = {};

        toArray(sourceComments.querySelectorAll('.editorial-instagram__comment-entry')).forEach(function(entry){
          serverKeys[getCommentEntryKey(entry)] = true;
        });

        commentsContainer.innerHTML = sourceComments.innerHTML;

        pendingEntries.reverse().forEach(function(entry){
          var pendingKey = entry.getAttribute('data-comment-key') || getCommentEntryKey(entry);
          if(!serverKeys[pendingKey]){
            commentsContainer.insertBefore(entry, commentsContainer.firstChild);
          }
        });
      }).catch(function(){
        // Keep the existing comments when a background refresh is unavailable.
      }).then(function(){
        commentSyncBusy = false;
      });
    }

    var comments = readComments();
    if(!sharedComments) renderComments(comments);
    if(commentApiEnabled){
      var cachedApiComments = readApiCommentCache();
      if(cachedApiComments.length) renderComments(cachedApiComments);
      runWhenIdle(function(){ window.setTimeout(syncApiComments, 900); });
      commentSyncTimer = window.setInterval(syncApiComments, 15000);
      window.addEventListener('focus', syncApiComments);
      document.addEventListener('visibilitychange', function(){
        if(document.visibilityState === 'visible') syncApiComments();
      });
    } else if(sharedComments){
      if(commentFrame) commentFrame.addEventListener('load', handleCommentFrameLoad);
      runWhenIdle(function(){ window.setTimeout(syncSharedComments, 1800); });
      commentSyncTimer = window.setInterval(syncSharedComments, 15000);
      window.addEventListener('focus', syncSharedComments);
      document.addEventListener('visibilitychange', function(){
        if(document.visibilityState === 'visible') syncSharedComments();
      });
    }
    var isLiked = readLikeState();
    syncLikeState(isLiked);

    if(likeButton){
      likeButton.addEventListener('click', function(){
        isLiked = !isLiked;
        writeLikeState(isLiked);
        syncLikeState(isLiked);
      });
    }

    if(shareButton){
      shareButton.addEventListener('click', copyShareLink);
    }

    if(commentTrigger && commentInput){
      commentTrigger.addEventListener('click', function(){ commentInput.focus(); });
    }

    if(emojiToggle && emojiPicker){
      buildEmojiPicker();
      emojiToggle.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        setEmojiPickerOpen(!emojiPicker.classList.contains('is-open'));
      });
      emojiPicker.addEventListener('click', function(e){
        var option = e.target.closest('[data-instagram-emoji-code]');
        if(!option) return;
        e.preventDefault();
        e.stopPropagation();
        insertEmoji(emojiFromCodeSequence(option.getAttribute('data-instagram-emoji-code')));
      });
      document.addEventListener('click', function(e){
        if(!emojiPicker.contains(e.target) && e.target !== emojiToggle) setEmojiPickerOpen(false);
      });
    }

    if(commentsContainer && !sharedComments){
      commentsContainer.addEventListener('click', function(e){
        var deleteButton = e.target.closest('[data-instagram-comment-delete]');
        if(!deleteButton) return;
        var commentId = deleteButton.getAttribute('data-instagram-comment-delete');
        comments = comments.filter(function(comment){ return comment.id !== commentId; });
        writeComments(comments);
        renderComments(comments);
        showCommentFeedback('Comment deleted.');
      });
    }

    if(commentInput && commentSubmit){
      commentInput.addEventListener('input', function(){
        commentSubmit.disabled = !commentInput.value.trim();
      });
    }

    if(commentForm && commentInput){
      commentForm.addEventListener('submit', function(e){
        e.preventDefault();
        var value = commentInput.value.trim();
        if(!value) return;
        var moderation = moderateComment(value);

        if(moderation.matched && blockedCommentAction === 'reject'){
          showCommentFeedback('Comment not posted because it contains blocked language.');
          return;
        }

        if(commentApiEnabled){
          if(commentSubmitting) return;
          commentSubmitting = true;
          pendingSharedComment = moderation.text;
          if(commentSubmit){
            commentSubmit.disabled = true;
            commentSubmit.textContent = 'Posting...';
          }
          setEmojiPickerOpen(false);
          startApiCommentSubmission();
          return;
        }

        if(sharedComments){
          commentInput.value = moderation.text;

          if(useNativeMobileCommentSubmission()){
            if(commentSubmit){
              commentSubmit.disabled = true;
              commentSubmit.textContent = 'Posting...';
            }

            commentForm.removeAttribute('target');
            showCommentFeedback('Posting comment...');
            HTMLFormElement.prototype.submit.call(commentForm);
            return;
          }

          if(commentSubmitting) return;
          commentSubmitting = true;
          pendingSharedComment = moderation.text;

          if(commentSubmit){
            commentSubmit.disabled = true;
            commentSubmit.textContent = 'Posting...';
          }

          if(commentFrame && commentFrame.name){
            commentForm.setAttribute('target', commentFrame.name);
          }

          try {
            HTMLFormElement.prototype.submit.call(commentForm);
            showCommentFeedback('Submitting comment...');
            commentResponseTimer = window.setTimeout(function(){
              if(commentSubmitting){
                showCommentFeedback('Shopify is still checking this comment.');
              }
            }, 12000);
          } catch(error){
            showCommentFeedback('Comment submission is temporarily unavailable.');
            resetSharedCommentSubmission();
          }
          return;
        }

        comments.push({ id: createCommentId(), username: commentUsername, text: moderation.text, time: 'now' });
        comments = comments.slice(-50);
        writeComments(comments);
        renderComments(comments);
        commentInput.value = '';
        if(commentSubmit) commentSubmit.disabled = true;
        if(moderation.matched) showCommentFeedback('Blocked language was filtered.');
      });
    }

    campaign.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){
        closeHotspots(null);
        setEmojiPickerOpen(false);
      }
    });
  }

  function initSignalGame(wrapper){
    if(wrapper.dataset.signalGameInitialized === 'true') return;
    wrapper.dataset.signalGameInitialized = 'true';

    var isEnabled = wrapper.getAttribute('data-signal-game-enabled') === 'true';
    var fallbackSequence = parseCommaList(wrapper.getAttribute('data-signal-game-sequence'));
    var persistUnlock = wrapper.getAttribute('data-signal-persist-unlock') === 'true';
    var autoScroll = wrapper.getAttribute('data-signal-auto-scroll') === 'true';
    var sectionId = wrapper.getAttribute('data-editorial-grid-section') || '';
    var overlay = document.querySelector('.editorial-signal-game-overlay[data-signal-game-section="' + sectionId + '"]');
    var states = {};
    wrapper.__signalStates = states;

    function getGroupState(groupName){
      var normalizedGroup = normalizeFilterValue(groupName || 'alpha');
      if(!states[normalizedGroup]){
        states[normalizedGroup] = {
          group: normalizedGroup,
          sequence: fallbackSequence.slice(),
          progress: [],
          unlocked: false,
          tiles: [],
          rewards: [],
          transientStatusText: '',
          statusTimer: null,
          messages: {
            prompt: 'Tap in order',
            error: 'Wrong route. Start again.',
            successStatus: 'Route open',
            successKicker: 'Route unlocked',
            successHeading: 'Secret reward revealed',
            successBody: ''
          }
        };
      }
      return states[normalizedGroup];
    }

    if(overlay && overlay.dataset.initialized !== 'true'){
      overlay.dataset.initialized = 'true';
      var closeButton = overlay.querySelector('[data-signal-game-close]');
      if(closeButton){ closeButton.addEventListener('click', function(){ closeSignalGameOverlay(overlay); }); }
      overlay.addEventListener('click', function(e){ if(e.target === overlay) closeSignalGameOverlay(overlay); });
    }

    wrapper.querySelectorAll('[data-signal-reward]').forEach(function(reward){
      var rewardState = getGroupState(reward.getAttribute('data-game-group'));
      var rewardSequence = parseCommaList(reward.getAttribute('data-unlock-sequence'));
      var rewardItem = reward.closest('.grid-item');

      rewardState.rewards.push({ item: rewardItem, panel: reward });

      if(rewardSequence.length) rewardState.sequence = rewardSequence;
      if(reward.getAttribute('data-start-unlocked') === 'true') rewardState.unlocked = true;

      var instructionText = reward.getAttribute('data-instruction-text');
      var errorMessage = reward.getAttribute('data-error-message');
      var successStatus = reward.getAttribute('data-success-status');
      var successKicker = reward.getAttribute('data-success-kicker');
      var successHeading = reward.getAttribute('data-success-heading');
      var successBody = reward.getAttribute('data-success-body');

      if(instructionText) rewardState.messages.prompt = instructionText;
      if(errorMessage) rewardState.messages.error = errorMessage;
      if(successStatus) rewardState.messages.successStatus = successStatus;
      if(successKicker) rewardState.messages.successKicker = successKicker;
      if(successHeading) rewardState.messages.successHeading = successHeading;
      if(successBody) rewardState.messages.successBody = successBody;
    });

    wrapper.querySelectorAll('[data-signal-tile][data-tile-mode="game"]').forEach(function(tile){
      var tileState = getGroupState(tile.getAttribute('data-game-group'));
      tileState.tiles.push(tile);

      if(tile.dataset.initialized === 'true') return;
      tile.dataset.initialized = 'true';

      tile.addEventListener('click', function(){
        if(!isEnabled) return;

        var activeState = getGroupState(tile.getAttribute('data-game-group'));

        if(activeState.unlocked){
          if(activeState.rewards[0] && activeState.rewards[0].item && autoScroll){
            activeState.rewards[0].item.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            openSignalGameOverlay(overlay);
          }
          return;
        }

        if(!activeState.sequence.length) return;

        var value = normalizeFilterValue(tile.getAttribute('data-game-value'));
        var nextExpected = activeState.sequence[activeState.progress.length];

        tile.classList.add('is-armed');
        window.setTimeout(function(){ tile.classList.remove('is-armed'); }, 220);

        if(value === nextExpected){
          activeState.progress.push(value);

          if(activeState.progress.length >= activeState.sequence.length){
            activeState.unlocked = true;
            activeState.progress = activeState.sequence.slice();

            if(persistUnlock) writeSignalUnlock(sectionId, activeState.group, true);

            setTransientSignalStatus(wrapper, activeState, activeState.messages.successStatus || 'Route open', 1800);

            showSignalFeedback(wrapper, {
              type: 'success',
              kicker: activeState.messages.successKicker || 'Route unlocked',
              heading: activeState.messages.successHeading || 'Secret reward revealed',
              body: activeState.messages.successBody || '',
              duration: 2800
            });

            if(activeState.rewards.length){
              revealSignalRewards(wrapper, activeState, { scroll: autoScroll });
            } else {
              openSignalGameOverlay(overlay);
            }
          }

          syncSignalTiles(wrapper);
          return;
        }

        activeState.progress = [];
        if(persistUnlock) writeSignalUnlock(sectionId, activeState.group, false);

        flashSignalError(activeState);
        setTransientSignalStatus(wrapper, activeState, 'Wrong route', 1200);

        showSignalFeedback(wrapper, {
          type: 'error',
          kicker: 'Wrong route',
          heading: 'Sequence reset',
          body: activeState.messages.error || 'Start again.',
          duration: 2200
        });

        syncSignalTiles(wrapper);
      });
    });

    Object.keys(states).forEach(function(groupName){
      var state = states[groupName];
      if(persistUnlock && !state.unlocked && readSignalUnlock(sectionId, groupName)) state.unlocked = true;
      if(state.unlocked){
        state.progress = state.sequence.slice();
        if(state.rewards.length) revealSignalRewards(wrapper, state, { instant: true, scroll: false });
      }
    });

    syncSignalTiles(wrapper);
  }

  function initEditorialGrid(scope){
    var root = scope || document;

    root.querySelectorAll('.music-block').forEach(initMusicBlock);
    root.querySelectorAll('[data-terminal-text]').forEach(initTerminalText);
    root.querySelectorAll('[data-autoplay-video]').forEach(initAutoplayVideo);
    root.querySelectorAll('[data-editorial-grid-section]').forEach(initSignalGame);
    initWhenNear('[data-new-arrivals-drawer]', initNewArrivalsDrawer, root);
    initWhenNear('[data-carousel]', initCarousel, root);
    initWhenNear('[data-reveal-block]', initRevealBlock, root);
    initWhenNear('[data-cctv-board]', initCctvBoard, root);
    initWhenNear('[data-instagram-campaign]', initInstagramCampaign, root);

    updatePrimaryFilterBar();
    document.querySelectorAll('.filter-bar').forEach(initFilterBar);
    refreshAllFilterBars();

    if(!window.__editorialGridCloseHandlerBound){
      window.__editorialGridCloseHandlerBound = true;
      document.addEventListener('click', function(e){
        document.querySelectorAll('.filter-bar.open').forEach(function(filterBar){
          if(!filterBar.contains(e.target)) filterBar.classList.remove('open');
        });
      });
    }

    if(!window.__editorialGridEscapeResetBound){
      window.__editorialGridEscapeResetBound = true;
      document.addEventListener('keydown', function(e){
        if(e.key === 'Escape'){
          document.querySelectorAll('.editorial-signal-game-overlay.is-open').forEach(function(overlay){ closeSignalGameOverlay(overlay); });
          document.querySelectorAll('[data-editorial-grid-section]').forEach(function(sectionWrapper){ hideSignalFeedback(sectionWrapper); });
        }
        if(e.key === 'Escape' && getCurrentGlobalFilter() !== 'all'){
          setActiveFilterButtons('all');
          applyGlobalFilter('all', { animate: true });
          closeAllFilterBars();
        }
      });
    }

    if(!window.__editorialGridMobileMenuObserverBound){
      window.__editorialGridMobileMenuObserverBound = true;
      function checkMobileMenuState(){ if(isMobileMenuOpen()) closeAllFilterBars(); }
      checkMobileMenuState();

      if(window.MutationObserver && document.body){
        var mobileMenuObserver = new MutationObserver(function(){ checkMobileMenuState(); });
        mobileMenuObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      }

      document.addEventListener('click', function(e){
        if(e.target.closest('[js-open-mobile-nav], [js-close-mobile-nav], .site-header__mobile-nav')){
          window.setTimeout(checkMobileMenuState, 0);
          window.setTimeout(checkMobileMenuState, 120);
          window.setTimeout(checkMobileMenuState, 300);
        }
      }, true);
    }

    if(!window.__editorialGridVisibilityReplayBound){
      window.__editorialGridVisibilityReplayBound = true;
      document.addEventListener('visibilitychange', function(){
        document.querySelectorAll('[data-autoplay-video]').forEach(function(video){
          if(document.visibilityState === 'visible' && video.dataset.inViewport === 'true' && typeof video.__editorialPlay === 'function') video.__editorialPlay();
          if(document.visibilityState !== 'visible' && typeof video.__editorialPause === 'function') video.__editorialPause();
        });
      });
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initEditorialGrid(document); });
  } else {
    initEditorialGrid(document);
  }

  document.addEventListener('shopify:section:load', function(event){
    initEditorialGrid(event.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
